import React, { useState } from 'react';

import { useIntl } from 'react-intl';

import { Popup } from '@atlaskit/popup/popup';
import type { TriggerProps } from '@atlaskit/popup/types';
import { layers } from '@atlaskit/theme/constants';

import { messages } from '../../../../messages';

import { PopupButton, PopupContentWrapper } from './styled';

export interface SelectListCardHeadingInfoProps {
	groupDescription?: string;
	groupDescriptionIcon?: React.ReactElement<any>;
	groupDescriptionInfoLink?: string;
	groupDescriptionInfoLinkMessage?: string;
	groupName?: string;
	isHidden?: boolean;
	testId?: string;
}

export const SelectListCardHeadingInfo = ({
	testId,
	groupDescription,
	groupDescriptionInfoLink,
	groupDescriptionIcon,
	groupDescriptionInfoLinkMessage,
	groupName,
}: SelectListCardHeadingInfoProps): React.JSX.Element => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const intl = useIntl();

	const handleTogglePopup = () => setIsOpen(!isOpen);

	const handleClosePopup = () => setIsOpen(false);

	const popUpContent = () => (
		<PopupContentWrapper>
			<div data-testid={`${testId}-popup-description`}>{groupDescription}</div>
			{/* eslint-disable-next-line @atlaskit/design-system/no-html-anchor */}
			<a href={groupDescriptionInfoLink} target="_blank" data-testid={`${testId}-info-link`}>
				{groupDescriptionInfoLinkMessage}
			</a>
		</PopupContentWrapper>
	);

	const popUpTrigger = (triggerProps: TriggerProps) => (
		<PopupButton
			{...triggerProps}
			appearance="subtle"
			spacing="none"
			onClick={handleTogglePopup}
			testId={`${testId}-description-icon`}
			aria-label={intl.formatMessage(messages.groupInfoButton, { groupName })}
		>
			{groupDescriptionIcon}
		</PopupButton>
	);

	return (
		<Popup
			zIndex={layers.modal()}
			placement="right"
			isOpen={isOpen}
			onClose={handleClosePopup}
			content={popUpContent}
			trigger={popUpTrigger}
		/>
	);
};
